import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
  Modal,
  ModalBody,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { resetLoginFlag } from "../../slices/thunks";
import { login } from "../../slices/qaManagment/authentication/thunk";

import { createSelector } from "reselect";
import { getLoggedInUser } from "../../helpers/fakebackend_helper";

import imageLogo from "../../assets/orderingSystem/login-bg.jpg";
import logo from "../../assets/schedie/schedielogo.svg";
import arrow from "../../assets/schedie/curveArrow.svg";
import MobileSavedUser from "./component/MobileSavedUser";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Login = (props) => {
  const authuser = getLoggedInUser();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);
  const loginerror = useSelector((state) => state.Auth.errorMsg);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState(""); // Changed to PascalCase for consistency
  const [passwordShow, setPasswordShow] = useState(false);
  const [showUserSheet, setShowUserSheet] = useState(false);
  const [savedUsers, setSavedUsers] = useState(() => {
    const storedUsers = localStorage.getItem("savedUsers");
    if (!storedUsers) return [];
    const parsedUsers = JSON.parse(storedUsers);

    // Remove duplicates based on email
    const uniqueUsers = parsedUsers.filter(
      (v, i, a) => a.findIndex((u) => u.user.email === v.user.email) === i
    );
    return uniqueUsers;
  });

  const toggleUserSheet = () => setShowUserSheet(!showUserSheet);

  // Get the saved users (parsed into array or default to empty array)

  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));

  const { user, error, errorMsg } = useSelector(loginpageData);
  const [userLogin, setUserLogin] = useState([]);

  useEffect(() => {
    if (user) {
      const updatedUserData =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? user.multiFactor.user.email
          : user.user.email;
      const updatedUserPassword =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? ""
          : user.user.confirm_password;
      setUserLogin({
        username: updatedUserData,
        password: updatedUserPassword,
      });
    }
  }, [user]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: username, // Initialize with username state
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        dispatch({ type: "LOGIN_LOADING" });

        await dispatch(login(values, props.router.navigate));

        if (
          isAuthenticated &&
          (authuser.associatedRoles.includes("SuperAdmin") ||
            authuser.associatedRoles.includes("SystemAdmin"))
        ) {
          navigate("/dashboard");
        } else if (
          isAuthenticated &&
          authuser.associatedRoles.includes("SystemUser")
        ) {
          navigate("/pos");
        }
      } catch (error) {
        console.error("Login failed:", error);
      } finally {
        setLoading(false);
        dispatch({ type: "LOGIN_LOADED" });
      }
    },
  });

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  const handleForgotPasswordClick = () => {
    console.log(username);
    navigate("/forgot-password");
  };

  // New handler for card click to auto-fill email
  const handleCardClick = (email) => {
    setUsername(email);
    validation.setFieldValue("username", email);
  };

  // Function to delete a user
  const handleDeleteUser = (email) => {
    const updatedUsers = savedUsers.filter(
      (item) => item?.user?.email !== email
    );
    setSavedUsers(updatedUsers);
    localStorage.setItem("savedUsers", JSON.stringify(updatedUsers));
  };

  document.title = "Ordering System";
  useEffect(() => {
    if (user) {
      // Get email and roles based on auth type
      const email =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? user.multiFactor.user.email
          : user.user.email;

      const roles =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? ["User"]
          : user.user.associatedRoles || ["User"];

      // Check if user already exists in savedUsers
      const userExists = savedUsers.some((item) => item.user.email === email);

      if (!userExists) {
        const newUser = { user: { email, roles } };
        const updatedUsers = [...savedUsers, newUser];

        setSavedUsers(updatedUsers);
        localStorage.setItem("savedUsers", JSON.stringify(updatedUsers));
      }
    }
  }, [user]); // Run whenever `user` changes

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="vh-100">
          <Row className="h-100 g-0">
            {/* Login Form - Large screens */}
            <Col
              lg={{ size: 5, order: 2 }}
              md={{ size: 5, order: 2 }}
              xs={{ size: 12, order: 1 }}
              sm={{ size: 12, order: 1 }}
              xl={{ size: 6, order: 2 }}
              className="h-100 d-none d-sm-none d-md-block d-lg-block"
              style={{ backgroundColor: "#0f403b" }}
            >
              <div className="py-5 d-flex flex-column justify-content-center align-items-center h-100">
                <CardBody className="p-4">
                  <div className="text-center mb-lg-4 mb-1">
                    <h5 className="text-white">
                      Sign in to continue to Ordering System admin panel.
                    </h5>
                  </div>

                  {errorMsg && errorMsg ? (
                    <Alert color="danger"> {errorMsg} </Alert>
                  ) : null}

                  <div className="p-2 py-4">
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                      action="#" 
                    >
                      <div className="mb-3">
                        <Input
                          name="username"
                          className="form-control p-3"
                          placeholder="Enter email"
                          type="text"
                          onChange={(e) => {
                            validation.handleChange(e);
                            setUsername(e.target.value);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.username || ""}
                          invalid={
                            validation.touched.username &&
                            validation.errors.username
                              ? true
                              : false
                          }
                        />
                        {validation.touched.username &&
                        validation.errors.username ? (
                          <FormFeedback type="invalid">
                            {validation.errors.username}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3 mt-1">
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={passwordShow ? "text" : "password"}
                            className="form-control pe-5 p-3"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                          <button
                            className="btn btn-link position-absolute end-0 top-0 pt-3 text-decoration-none text-muted"
                            type="button"
                            id="password-addon"
                            onClick={() => setPasswordShow(!passwordShow)}
                          >
                            <i className="ri-eye-fill align-middle"></i>
                          </button>
                        </div>
                      </div>

                      <div className="d-flex justify-content-between mb-4">
                        <div className="form-check">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="auth-remember-check"
                          />
                          <Label
                            className="form-check-label text-white mt-0"
                            htmlFor="auth-remember-check"
                          >
                            Remember me
                          </Label>
                        </div>

                        <div className="float-end">
                          <Link
                            to="/forgot-password"
                            className="text-white"
                            onClick={handleForgotPasswordClick}
                          >
                            Forgot password?
                          </Link>
                        </div>
                      </div>

                      <div className="mb-3">
                        <Button
                          disabled={error ? null : loading ? true : false}
                          color="success"
                          className="btn btn-success w-100"
                          type="submit"
                        >
                          {loading ? (
                            <Spinner size="sm" className="me-2">
                              Loading...
                            </Spinner>
                          ) : null}
                          Sign In
                        </Button>
                      </div>
                      <Col xs={12} lg={12} className="d-lg-block d-none">
                        <div className="text-center text-white">
                          Not registered account?{" "}
                          <Link
                            to="/org-register"
                            className="text-warning"
                            onClick={handleForgotPasswordClick}
                          >
                            Register
                          </Link>
                        </div>
                      </Col>
                    </Form>
                  </div>
                </CardBody>

                <footer className="mt-auto w-100">
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div className="text-center">
                          <p className="mb-0 text-muted">
                            &copy; {new Date().getFullYear()} Danfe solution
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </footer>
              </div>
            </Col>

            {/* Login Form - Small screens */}
            <Col
              lg={{ size: 5, order: 2 }}
              xs={{ size: 12, order: 1 }}
              sm={{ size: 12, order: 1 }}
              xl={{ size: 6, order: 2 }}
              className="h-100 d-block d-sm-block d-md-none d-lg-none"
            >
              <img
                src={imageLogo}
                alt="Driving Instructor"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div
                className="py-5 d-flex flex-column justify-content-center align-content-center align-items-center h-100"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "start",
                  alignContent: "start",
                }}
              >
                <CardBody className="p-2 d-block justify-content-center align-content-center align-items-center">
                  <div className="text-center">
                    <h3
                      style={{ color: "white" }}
                      className="fw-bold mb-4 d-lg-none d-block"
                    >
                      Ordering Management System
                      <img src={arrow} alt="" className="w-25" />
                    </h3>
                    <h6 className="text-light">
                      Sign in to continue to Ordering System admin panel.
                    </h6>
                  </div>

                  {errorMsg && errorMsg ? (
                    <Alert color="danger"> {errorMsg} </Alert>
                  ) : null}

                  <div className="p-2 py-3">
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                      action="#"
                    >
                      <div className="mb-3">
                        <Input
                          name="username"
                          className="form-control p-3"
                          placeholder="Enter email"
                          type="text"
                          onChange={(e) => {
                            validation.handleChange(e);
                            setUsername(e.target.value);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.username || ""}
                          invalid={
                            validation.touched.username &&
                            validation.errors.username
                              ? true
                              : false
                          }
                        />
                        {validation.touched.username &&
                        validation.errors.username ? (
                          <FormFeedback type="invalid">
                            {validation.errors.username}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3 mt-1">
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={passwordShow ? "text" : "password"}
                            className="form-control pe-5 p-3"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                          <button
                            className="btn btn-link position-absolute end-0 top-0 pt-3 text-decoration-none text-muted"
                            type="button"
                            id="password-addon"
                            onClick={() => setPasswordShow(!passwordShow)}
                          >
                            <i className="ri-eye-fill align-middle"></i>
                          </button>
                        </div>
                      </div>

                      <Row className="d-flex justify-content-between mb-4">
                        <Col xs={12} lg={6}>
                          <div className="form-check">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="auth-remember-check"
                            />
                            <Label
                              className="form-check-label text-white mt-0"
                              htmlFor="auth-remember-check"
                            >
                              Remember me
                            </Label>
                          </div>
                        </Col>

                        <Col xs={12} lg={6} className="d-lg-block d-none">
                          <div className="float-end">
                            <Link
                              to="/forgot-password"
                              className="text-white"
                              onClick={handleForgotPasswordClick}
                            >
                              Forgot password?
                            </Link>
                          </div>
                        </Col>
                      </Row>

                      <div className="mb-3">
                        <Button
                          disabled={error ? null : loading ? true : false}
                          color="success"
                          className="btn btn-success w-100"
                          type="submit"
                        >
                          {loading ? (
                            <Spinner size="sm" className="me-2">
                              Loading...
                            </Spinner>
                          ) : null}
                          Sign In
                        </Button>
                      </div>

                      <Col xs={12} lg={6} className="d-lg-none d-block mb-4">
                        <div className="text-center">
                          <Link
                            to="/forgot-password"
                            className="text-white"
                            onClick={handleForgotPasswordClick}
                          >
                            Forgot password?
                          </Link>
                        </div>
                      </Col>
                      <Col xs={12} lg={6} className="d-lg-none d-block">
                        <div className="text-center text-white">
                          Not registered account?{" "}
                          <Link
                            to="/org-register"
                            className="text-warning"
                            onClick={handleForgotPasswordClick}
                          >
                            Register
                          </Link>
                        </div>
                      </Col>
                    </Form>
                  </div>
                </CardBody>

                <footer className="mt-auto w-100">
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div className="text-center">
                          <p className="mb-0 text-muted">
                            &copy; {new Date().getFullYear()} Danfe solution
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </footer>
              </div>
            </Col>

            {/* Image Part with User Cards */}
            <Col
              lg={{ size: 7, order: 1 }}
              md={{ size: 7, order: 1 }}
              xl={{ size: 6, order: 1 }}
              xs={{ size: 12, order: 2 }}
              sm={{ size: 12, order: 2 }}
              className="position-relative h-100 d-none d-sm-none d-md-flex d-lg-flex"
            >
              {/* Background Image */}
              <img src={imageLogo} alt="Background" className="login-image" />

              {/* Overlay */}
              <div className="login-overlay d-flex flex-column justify-content-center align-items-start">
                <div className="overlay-content w-100 px-4">
                  <h1 className="fw-bold display-5 mb-4 text-white d-flex align-items-center">
                    Ordering Management System
                    <img
                      src={arrow}
                      alt=""
                      className="ms-2"
                      style={{ height: "40px" }}
                    />
                  </h1>
                  <div>
                    {/* Swiper */}
                    <Swiper
                      modules={[Navigation, Pagination]}
                      spaceBetween={20}
                      slidesPerView={1} // default for xs
                      breakpoints={{
                        576: { slidesPerView: 2 }, // sm
                        768: { slidesPerView: 2 }, // md
                        992: { slidesPerView: 2 }, // lg - 2 cards per row
                        1200: { slidesPerView: 2 }, // xl - still 2 cards
                      }}
                      loop={true}
                      className="py-3"
                      navigation
                    >
                      {savedUsers?.map((item, index) => (
                        <SwiperSlide key={index}>
                          <Card
                            onClick={() => handleCardClick(item?.user?.email)}
                            className="user-card text-center p-2 border-0 cursor-pointer h-100  shadow-sm"
                          >
                            <Row className="align-items-center g-2">
                              {/* Avatar */}
                              <Col
                                xs={3}
                                className="d-flex justify-content-center"
                              >
                                <div
                                  className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    fontSize: "1.1rem",
                                    fontWeight: "700",
                                  }}
                                >
                                  {item?.user?.email
                                    ?.substring(0, 2)
                                    .toUpperCase()}
                                </div>
                              </Col>

                              {/* User Info */}
                              <Col xs={9} className="text-start">
                                <h6 className="mb-1 text-white fw-bold text-truncate text-start">
                                  {item?.user?.email}
                                </h6>
                                <div className="d-flex justify-content-between align-content-center align-items-center">
                                  <span className="badge rounded-pill bg-light text-dark shadow-sm">
                                    {item?.user?.roles[0]}
                                  </span>
                                  <button
                                    className="btn btn-sm"
                                    onClick={() =>
                                      handleDeleteUser(item?.user?.email)
                                    }
                                  >
                                    <i className="ri-delete-bin-line text-danger"></i>
                                  </button>
                                </div>
                              </Col>
                            </Row>
                          </Card>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </ParticlesAuth>

      <div
        className="d-sm-block d-md-none position-fixed bottom-0 start-0 w-100 text-center mb-2"
        style={{ zIndex: 1050 }}
        onClick={toggleUserSheet}
      >
        <div
          style={{
            width: "100px",
            height: "6px",
            background: "#bbb",
            borderRadius: "5px",
            margin: "0 auto",
          }}
        ></div>
      </div>
      <MobileSavedUser
        showUserSheet={showUserSheet}
        toggleUserSheet={toggleUserSheet}
        savedUsers={savedUsers}
        handleCardClick={handleCardClick}
        handleDeleteUser={handleDeleteUser}
      />
    </React.Fragment>
  );
};

export default withRouter(Login);
